import { startG3Telemetry } from "./g3-telemetry/index.js";
import "./style.css";

const g3 = startG3Telemetry({
  ingestUrl: G3_INGEST_URL,
  reportToken: G3_REPORT_TOKEN,
  commit: G3_COMMIT_SHA,
  deployUrl: G3_DEPLOY_URL,
});

const list = document.querySelector("#list");
const errorEl = document.querySelector("#error");
let counters = [];
let queue = Promise.resolve();
const serial = (f) => (queue = queue.then(f, f));

async function api(path = "", method = "GET", body) {
  try {
    const res = await fetch(`/api/counters${path}`, {
      method,
      headers: body ? { "content-type": "application/json" } : {},
      body: body && JSON.stringify(body),
    });
    if (!res.ok) throw new Error(String(res.status));
    errorEl.textContent = "";
    return res.status === 204 ? null : res.json();
  } catch {
    errorEl.textContent = "Something went wrong. Try again.";
    throw new Error("api");
  }
}

function button(label, text, onClick) {
  const b = document.createElement("button");
  b.setAttribute("aria-label", label);
  b.textContent = text;
  b.onclick = () => onClick().catch(() => {});
  return b;
}

function render() {
  list.replaceChildren(...counters.map((c) => {
    const li = document.createElement("li");
    li.className = "counter";
    const name = Object.assign(document.createElement("span"), { className: "name", textContent: c.name });
    const value = Object.assign(document.createElement("span"), { className: "value", textContent: String(c.value) });
    li.append(
      name,
      button("decrement", "-", () => step(c.id, -1)),
      value,
      button("increment", "+", () => step(c.id, 1)),
      button("delete", "Delete", () => remove(c.id)),
    );
    return li;
  }));
}

const step = (id, delta) => serial(async () => {
  const row = await api(`/${id}`, "PATCH", { delta });
  counters = counters.map((c) => (c.id === id ? row : c));
  render();
});

const remove = (id) => serial(async () => {
  await api(`/${id}`, "DELETE");
  counters = counters.filter((c) => c.id !== id);
  render();
});

document.querySelector("#add-form").onsubmit = async (e) => {
  e.preventDefault();
  const input = document.querySelector("#name");
  try {
    await serial(async () => {
      counters.push(await api("", "POST", { name: input.value }));
      input.value = "";
      render();
    });
  } catch {}
};

serial(async () => { counters = await api(); render(); }).catch(() => {});
